import React from 'react';
import PropTypes from 'prop-types';
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

/* Open-source ProgressProvider by kevinsqi@github (author of react-circular-progressbar) */
const ProgressProvider = ({ valueStart, valueEnd, children }) => {
  const [value, setValue] = React.useState(valueStart);
  React.useEffect(() => {
    setValue(valueEnd);
  }, [valueEnd]);

  return children(value);
};

/* Circular progressbar component with an initial animation */
const AnimatedCircleProgress = ({ children, progress, ...rest }) => {
  return (
    <ProgressProvider valueStart={0} valueEnd={progress}>
      {(value) => (
        <CircularProgressbarWithChildren value={value} {...rest}>
          {children}
        </CircularProgressbarWithChildren>
      )}
    </ProgressProvider>
  );
};

/* The actual exported component used in the Game Mode modal - supports two nested bars */
const CircleProgress = ({
  children,
  primary = 0,
  secondary = 0,
  success = true,
}) => {
  const color = success ? '#75d93e' : '#ea7979';
  const colorTransparent = `${color}15`;

  const sharedStyles = {
    strokeLinecap: 'butt',
    pathTransitionDuration: 1.0,
  };

  return (
    <AnimatedCircleProgress
      progress={secondary}
      styles={buildStyles({
        pathColor: colorTransparent,
        ...sharedStyles,
      })}
    >
      <AnimatedCircleProgress
        progress={primary}
        styles={buildStyles({
          pathColor: color,
          trailColor: 'transparent',
          ...sharedStyles,
        })}
      >
        {children}
      </AnimatedCircleProgress>
    </AnimatedCircleProgress>
  );
};

CircleProgress.propTypes = {
  children: PropTypes.node,
  primary: PropTypes.number,
  secondary: PropTypes.number,
  success: PropTypes.bool,
};
CircleProgress.defaultProps = {
  primary: 0,
  secondary: 0,
  success: true,
};

export default CircleProgress;
